import * as React from 'react';
import { DataNode, IconType } from 'rc-tree/lib/interface';

export type LangCodes =
    'en_UK'
    | 'en_US'
    | 'zh_CN'
    | 'cs_CZ'
    | 'da_DK'
    | 'fi_FI'
    | 'fr_FR'
    | 'hu_HU'
    | 'de_DE'
    | 'it_IT'
    | 'ja_JP'
    | 'is_IS'
    | 'ko_KR'
    | 'nb_NO'
    | 'pl_PL'
    | 'pt_BR'
    | 'pt_PT'
    | 'ro_RO'
    | 'ru_RU'
    | 'sk_SK'
    | 'es_ES'
    | 'sv_SE';

export type LangNames =
    'English UK'
    | 'English US'
    | 'Chinese (China)'
    | 'Chinese (Taiwan)'
    | 'Czech'
    | 'Dutch'
    | 'Estonian'
    | 'Finnish'
    | 'French'
    | 'Hungarian'
    | 'German'
    | 'Icelandic'
    | 'Italian'
    | 'Japanese'
    | 'Korean'
    | 'Norwegian'
    | 'Polish'
    | 'Portuguese (Brazil)'
    | 'Portuguese (Portugal)'
    | 'Romanian'
    | 'Russian'
    | 'Slovak'
    | 'Spanish'
    | 'Swedish'
    | 'Turkish'
    | 'Vietnamese';

export type Translations = {
    [key: string]: string,
}

export const TRANSLATIONS: Translations = {
    en_UK: 'English UK',
    en_US: 'English US',
    zh_CN: 'Chinese (China)',
    zh_TW: 'Chinese (Taiwan)',
    cs_CZ: 'Czech',
    da_DK: 'Dutch',
    et_ET: 'Estonian',
    fi_FI: 'Finnish',
    fr_FR: 'French',
    hu_HU: 'Hungarian',
    de_DE: 'German',
    is_IS: 'Icelandic',
    it_IT: 'Italian',
    ja_JP: 'Japanese',
    ko_KR: 'Korean',
    nb_NO: 'Norwegian',
    pl_PL: 'Polish',
    pt_BR: 'Portuguese (Brazil)',
    pt_PT: 'Portuguese (Portugal)',
    ro_RO: 'Romanian',
    ru_RU: 'Russian',
    sk_SK: 'Slovak',
    es_ES: 'Spanish',
    sv_SE: 'Swedish',
    tr_TR: 'Turkish',
    vi_VI: 'Vietnamese',
};

export type CustomField = {
    id: string;
    name: string;
}

export type CustomDataNode = {
    value?: string;
    checkable?: boolean;
    translation?: Partial<Translations>;
    children?: CustomDataNode[];
    disabled?: boolean;
    disableCheckbox?: boolean;
    icon?: IconType;
    isLeaf?: boolean;
    key: string | number;
    title?: React.ReactNode;
    selectable?: boolean;
    switcherIcon?: IconType;
    className?: string;
    style?: React.CSSProperties;
    isDefaultOption?: boolean;
    isEnabled?: boolean;
} & DataNode

export type ViewContext = {
    locale: string,
    extension: {
        fieldId: string,
        renderContext?: string,
        fieldValue: any,
        issue: {
            id?: string,
            type: string,
            typeId: string,
        },
        project: {
            id: string,
            key?: string,
        }
    }
}


export type ErrorResponseObject = {
    getResponseHeader: () => string,
    responseText: {
        errorMessages: string[],
        errors: any,
    },
    status: number,
    statusText: string,
}

export type LevelsAsNumber =
    '_1'
    | '_2'
    | '_3'
    | '_4'
    | '_5'
    | '_6'
    | '_7';

export type LevelInfo = {
    parentOptionKey: string | undefined,
    firstOptionKey: string | undefined,
    levelInfo: {
        levelName: string,
        levelDescription: string,
        levelNameTranslation: Partial<Translations>,
        levelDescriptionTranslation: Partial<Translations>,
    }
}

export type LevelsInfo = {
    [key in LevelsAsNumber]: LevelInfo[]
}

export type LevelInfoDescriptionLink = {
    text: string,
    href: string,
}

export type ConfigModel = DataNode[] | string[];
